import * as Settings from "@equipmentshare/kernel/dist/runtime";

import * as Driver from "~/Driver";

export * as ClusterChart from "./ClusterChart";
export * as MapboxMap from "./MapboxMap";

export const mapboxKey: string = Settings.getSettings().vendor.mapboxKey;

export type FeatureProperties = {
  readonly id: string;
  readonly name: string;
  readonly status: Driver.Status.Actual.Actual;
  readonly appVersion: string;
  readonly osType: string;
  readonly osVersion: string;
};

export type CountProperties = {
  readonly driveCount: number;
  readonly onCount: number;
  readonly offCount: number;
  readonly sbCount: number;
  readonly ymCount: number;
  readonly puCount: number;
};
